
import { xeroActions } from "./xero-slice";
import { orderActions } from "./order-slice";
import { xeroApi } from "../Api";

export const getContact = (contactid) => {
    return async (dispatch) => {
        dispatch(xeroActions.Request_Contact())

        xeroApi.get(`/contacts/${contactid}`)
            .then(response => {
                dispatch(xeroActions.Request_Contact_Response(response.data))
            }).catch(err => {
                const msg =
                    err?.response?.data?.message ||
                    err?.response?.data ||
                    err?.message ||
                    'Unable to load customer details from Xero. Please try again.';

                dispatch(xeroActions.Request_Contact_Error(msg));

                const apiError = err?.response?.data?.error;
                if (apiError && (
                    apiError === 'xero_not_connected' ||
                    apiError === 'xero_invalid_or_expired')
                ) {
                    dispatch(xeroActions.Clear_Connection());
                }
            })
    }
}

export const getContacts = () => {

    return async (dispatch) => {
        dispatch(xeroActions.Request_Contacts())

        xeroApi.get('/contacts')
            .then(response => {
                dispatch(xeroActions.Request_Contacts_Response(response.data.Contacts))
            }).catch(err => {
                dispatch(xeroActions.Request_Contacts_Error(err.response.data.message));

                if (err?.response?.data?.error && (
                    err?.response?.data?.error === 'xero_not_connected' ||
                    err?.response?.data?.error === 'xero_invalid_or_expired'
                )) {
                    dispatch(xeroActions.Clear_Connection());
                }
            })
    }
}

export const syncXeroInvoiceToOrder = (order) => {
    return async (dispatch) => {
        dispatch(orderActions.Request_Order());

        xeroApi.post(`/sync-order-to-xero/${order._id}`)
            .then(response => {
                dispatch(orderActions.Request_Order_Response({ data: response.data, err: null }))
            }).catch(error => {
                dispatch(orderActions.Request_Order_Response({ data: null, err: error.response.data.message }))
            })
    }
}

export const getXeroConnection = () => {
    return async (dispatch) => {
        dispatch(xeroActions.Request_Connection());

        xeroApi.get('/connection')
            .then(res => {
                dispatch(xeroActions.Request_Connection_Response(res.data));
            })
            .catch(err => {
                const msg =
                    err?.response?.data?.message ||
                    err?.response?.data ||
                    err?.message ||
                    'Failed to load Xero connection';
                dispatch(xeroActions.Request_Connection_Error(msg));
            });
    };
};